import { TabPane } from './TabPane';
import TabInner from './Tabs';

export const Tabs = Object.assign(TabInner, { TabPane });

export * from './type';
